package org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.tab_general.component.select_days

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.select_days.DayWeekEnum
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.domain.util.parseWeekDaysNum
import org.hs_soft.runmynesto.pages.components.OutlinedBox
import org.hs_soft.runmynesto.pages.components.VectorIcon
import org.jetbrains.compose.web.css.px

@Composable
fun SelectDays(
    modifier: Modifier=Modifier,
    windowSizeMode: WindowSizeModeEnum,
    selectedDaysNumber: Int,
    onChangeDayCheckStatus:(Int)->Unit,
) {

    val selectedDays = parseWeekDaysNum(selectedDaysNumber)
    val isExpanded = remember { mutableStateOf(false) }

    Box(
        modifier = modifier
            .height(Dimen.outlinedEditTextParentHeight)
    )
    {
         OutlinedBox(
            label = Strings.current().selectDays,
            width = if (windowSizeMode!= WindowSizeModeEnum.Desktop)
                Dimen.semiLargeEditTextWidth
            else Dimen.templateContentGeneralInfoWidth,
            isExpanded = isExpanded.value,
            boxContent = {
                DaysChosenList(
                    windowSizeMode = windowSizeMode,
                    selectedDaysNumber = selectedDaysNumber,
                    selectedDays = selectedDays,
                    isExpanded=isExpanded.value,
                    onRowClick = {
                        isExpanded.value = !isExpanded.value
                    },
                    onChangeDayCheckStatus = {
                        onChangeDayCheckStatus(it)
                    },
                )

            },
            expandableList = {
                if (isExpanded.value) {
                    DaysCheckBoxList(
                        selectedDays = selectedDays,
                        selectedDaysNumber = selectedDaysNumber,
                        onChangeDayCheckStatus = {
                            onChangeDayCheckStatus(it)

                        },
                    )
                }
            },
             dismissExpandedList = {
               isExpanded.value=false
             }
        )

    }



}


@Composable
private fun DaysChosenList(
    windowSizeMode: WindowSizeModeEnum,
    selectedDays: List<DayWeekEnum>,
    isExpanded:Boolean,
    onChangeDayCheckStatus: (Int) -> Unit,
    selectedDaysNumber: Int,
    onRowClick: () -> Unit
) {
    Row(
        modifier = Modifier
            .minHeight(Dimen.mediumOutlinedEditTextHeight)
            .width(
                if (windowSizeMode!= WindowSizeModeEnum.Desktop)
                    Dimen.semiLargeEditTextWidth
                else{
                    (Dimen.templateContentGeneralInfoWidth.value.toInt()
                    -Dimen.largePadding.value.toInt()).px
                }
            )
            .onClick {
                onRowClick()
            },
        verticalAlignment = Alignment.CenterVertically
    )
    {

        Column(
            modifier = Modifier
                .padding(Dimen.smallPadding)
            ,verticalArrangement = Arrangement.Center

        ) {
            if (selectedDays.contains(DayWeekEnum.ALL_DAYS)) {
                SelectedDayItem(
                    modifier = Modifier
                        .margin(Dimen.extraSmallPadding),
                    name = DayWeekEnum.ALL_DAYS.title,
                    onDeleteClick = {
                        onChangeDayCheckStatus(0)
                    },
                )
            } else {
                if (windowSizeMode== WindowSizeModeEnum.PHONE){
                    DayWeekEnum.entries
                        .windowed(size = 4, step = 4)
                        .forEach { newRow ->
                            Row()
                            {
                                newRow.forEach { day ->
                                    if (selectedDays.contains(day)) {
                                        SelectedDayItem(
                                            modifier = Modifier
                                                .margin(Dimen.extraSmallPadding),
                                            name = day.title,
                                            onDeleteClick = {
                                                onChangeDayCheckStatus(selectedDaysNumber - day.value)
                                            },
                                        )
                                    }
                                }
                            }


                        }
                }else{
                    Row()
                    {
                        DayWeekEnum.entries.forEach {day->
                            if (selectedDays.contains(day)) {
                                SelectedDayItem(
                                    modifier = Modifier
                                        .margin(Dimen.extraSmallPadding),
                                    name = day.title,
                                    onDeleteClick = {
                                        onChangeDayCheckStatus(selectedDaysNumber - day.value)
                                    },
                                )
                            }
                        }
                    }
                }


            }


        }



        Spacer()

        VectorIcon(
            modifier = Modifier,
            width = Dimen.mediumIconSize,
            height = Dimen.mediumIconSize,
            pathData =if (isExpanded) Res.PathIcon.arrowTop
                else Res.PathIcon.arrowBelow,
            color = Theme.ActionActive.hex
        )

    }

}

@Composable
private fun DaysCheckBoxList(
    selectedDays: List<DayWeekEnum>,
    onChangeDayCheckStatus: (Int) -> Unit,
    selectedDaysNumber: Int
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
    ) {
        DayWeekEnum.entries.forEachIndexed {index,dayEnum ->
            CheckBoxDay(
                isChecked = selectedDays.contains(dayEnum),
                title = dayEnum.title,
                onChecked = {
                    if (dayEnum == DayWeekEnum.ALL_DAYS)
                        onChangeDayCheckStatus(DayWeekEnum.ALL_DAYS.value)
                    else onChangeDayCheckStatus(selectedDaysNumber + dayEnum.value)

                },
                onUnChecked = {
                    if (dayEnum == DayWeekEnum.ALL_DAYS)
                        onChangeDayCheckStatus(0)
                    else onChangeDayCheckStatus(selectedDaysNumber - dayEnum.value)
                }

            )
        }
    }


}
